import { Attributes, LookupBase } from '@singularsystems/neo-core';
import { isHidden } from '../../Config/FieldConfig/FieldSetting.enum';
import { AppService, DomainTypes } from '../../../DomainTypes';

export default class IssuerInvestmentLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public issuerInvestmentId: number = 0;

    public entityId: number = 0;

    public investmentId: number = 0;

    public investmentName: string = "";

    public issuerName: string = "";

    @Attributes.Float()
    public currentBalance: number = 0;

    public isIssuerRestricted: boolean = false;

    @Attributes.Nullable()
    public readonly productTypeId: number | null = null;

    public readonly productTypeFilterParent: boolean = false;

    // Client only properties / methods

    public get idAndIssuerName(): string {
        if (this.investmentName && !isHidden(AppService.get(DomainTypes.Services.DataCache).fieldConfig.issuerInvestmentFields.investmentName)) {
            return `${this.issuerInvestmentId} - ${this.investmentName} - ${this.issuerName}`;
        }
        else {
            return `${this.issuerInvestmentId} - ${this.issuerName}`;
        }
    }
}